import { render } from "./ViewEmailConfiguration.vue?vue&type=template&id=aba30768&scoped=true"
import script from "./ViewEmailConfiguration.vue?vue&type=script&lang=js"
export * from "./ViewEmailConfiguration.vue?vue&type=script&lang=js"

import "./email-configuration.scss?vue&type=style&index=0&id=aba30768&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba30768"]])

export default __exports__